import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MarketingActionButton, MarketingTrayButtonAction } from 'projects/osn-shared/src/common';
import { AbstractNavigationService } from '../../services';
import { AbstractPageScreenService } from '../page-screen/abstract-page-screen.service';

@Component({
  selector: 'osn-shared-marketing-action-button',
  templateUrl: './marketing-action-button.component.html',
  styleUrls: ['./marketing-action-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingActionButtonComponent {
  @Input() public buttonText = '';
  @Input() public actionButton: MarketingActionButton;
  @Input() public onMarketingLandingPage = true;
  @Input() public secondaryStyle = false;
  @Output() public measureClick = new EventEmitter<void>();
  constructor(private readonly navigationService: AbstractNavigationService, private readonly pageService: AbstractPageScreenService) {}

  public onClick(actionButton: MarketingActionButton) {
    this.measureClick.emit();

    switch (actionButton.action) {
      case MarketingTrayButtonAction.SignIn:
        this.pageService.signIn();
        break;
      case MarketingTrayButtonAction.SignUp:
      case MarketingTrayButtonAction.RenewOrCompleteSubscription: // GATEWAY will handle prospect and churned users
        this.pageService.signUp();
        break;
      case MarketingTrayButtonAction.NewPassword:
        this.pageService.addNewPassword();
        break;
      case MarketingTrayButtonAction.Content:
        const detailPageType = actionButton.targetContentGuid.startsWith('SR') ? 'seriesDetails' : 'movieDetails';
        this.navigationService.navigate(detailPageType, actionButton.targetContentGuid);
        break;
      case MarketingTrayButtonAction.CustomUrl:
        window.open(actionButton.targetUrl, '_blank');
        break;
      case MarketingTrayButtonAction.CxbPage:
        this.navigationService.navigate('page', actionButton.targetPageSlug);
        break;
      default:
        return;
    }
  }
}
